import { useContext, useEffect, useState } from 'react'
import api from '../api'
import MainContext from '../common/MainContext'
import { AdminRole } from '../common/constants'
import useContextMenu from '../common/hooks/useContextMenu'
import { formatSecondsDuration } from '../utils'
import { ReactComponent as RecordingIcon } from '../assets/images/icons/ic-video-lesson.svg'
import { ReactComponent as DownloadIcon } from '../assets/images/icons/ic-download.svg'
import { ReactComponent as DeleteIcon } from '../assets/images/icons/ic-delete.svg'
import AlertDialog from './dialogs/AlertDialog'
import styles from './DashboardDayAgenda.module.css'

export default function AgendaRecordings({ lesson, now }) {
    const context = useContext(MainContext)
    const { showMenu } = useContextMenu()
    const [recordings, setRecordings] = useState(lesson.recordings || [])
    const [busy, setBusy] = useState(null)
    const [error, setError] = useState('')
    const [deleting, setDeleting] = useState(null)
    useEffect(() => setRecordings(lesson.recordings || []), [lesson.recordings])
    const download = async recording => {
        setBusy(recording.id)
        setError('')
        try {
            const result = await api.get(`/admin/recordings/${recording.id}/download`)
            const link = document.createElement('a')
            link.href = result.download_link
            link.download = `${lesson.room_name}.mp4`
            document.body.appendChild(link)
            link.click()
            link.remove()
        } catch { setError('Download non disponibile. Riprova.') }
        finally { setBusy(null) }
    }
    if (!recordings.length) return null
    return <>
        <div className={styles.recordings} aria-label="Registrazioni della lezione">
            {recordings.map((recording, index) => {
                const ongoing = recording.status === 'in-progress'
                const duration = ongoing && recording.start_ts ? Math.max(0, Math.floor(now.getTime() / 1000) - recording.start_ts) : recording.duration || 0
                return <button type="button" key={recording.id} className={`${styles.recordingButton} ${ongoing ? styles.recordingActive : ''}`}
                    disabled={recording.status !== 'finished' || busy !== null}
                    title={ongoing ? 'Registrazione in corso' : recording.status === 'finished' ? 'Scarica registrazione' : 'Registrazione in elaborazione'}
                    aria-label={`${ongoing ? 'Registrazione in corso' : 'Scarica registrazione'} ${index + 1}, ${formatSecondsDuration(duration)}`}
                    onClick={() => download(recording)}
                    onContextMenu={event => {
                        if (recording.status === 'finished' && context?.user?.role === AdminRole.Main) showMenu(event, [
                            { name: 'Scarica', icon: <DownloadIcon />, onClick: () => download(recording) },
                            { name: 'Elimina', icon: <DeleteIcon />, onClick: () => setDeleting(recording.id) },
                        ])
                    }}><RecordingIcon aria-hidden="true" />{ongoing ? 'REC · ' : ''}{busy === recording.id ? 'Caricamento…' : formatSecondsDuration(duration)}</button>
            })}
        </div>
        {error && <span role="alert" className={styles.recordingError}>{error}</span>}
        <AlertDialog open={deleting !== null} title="Elimina registrazione" text={`Eliminare la registrazione della lezione “${lesson.name}”? L'operazione non può essere annullata.`} onClose={() => setDeleting(null)} actions={[{
            label: 'ELIMINA', confirmText: 'ELIMINA', accentColor: 'var(--sf-red)', onClick: async () => {
                try {
                    await api.delete(`/admin/recordings/${deleting}`)
                    setRecordings(items => items.filter(item => item.id !== deleting))
                } catch { setError('Impossibile eliminare la registrazione.') }
                setDeleting(null)
            },
        }]} />
    </>
}
